const actionTypes = {
  GET_BLOGS: 'GET_BLOGS',
  GET_SKILLS: 'GET_SKILLS',
  GET_PROJECTS: 'GET_PROJECTS',
  GET_CONTACTS: 'GET_CONTACTS'
};
export default actionTypes;